export default {

    name: "independent-search-box",
    path: "independent-search-box",
    component: () => import(/* webpackChunkName: "app-components-entry" */ './lib.vue')

}